import { get } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'

export const TIMEZONES_LOAD = 'TIMEZONES_LOAD'

let timezonesPromise = null

export default {
  namespaced: true,
  state: {
    timezonesLoaded: false,
    timezonesList: []
  },
  getters: {
    timezones(state) {
      return state.timezonesList
    },
    getTimezoneLabel: (state) => (id) => {
      let tz = state.timezonesList.find((t) => t.id === id)
      return tz ? `${tz.label} (${tz.offsetLabel})` : id
    }
  },
  mutations: {
    [TIMEZONES_LOAD](state, list) {
      state.timezonesList = list
      state.timezonesLoaded = true
    }
  },
  actions: {
    timezonesLoad({ commit, state }) {
      if (state.timezonesLoaded) {
        return Promise.resolve(state.timezonesList)
      }
      if (!timezonesPromise) {
        timezonesPromise = get(`/${UrlStore.TIMEZONES}`).then((r) => {
          commit(TIMEZONES_LOAD, r.data)
          return r.data
        })
      }
      return timezonesPromise
    }
  }
}
